<template>
  <section class="prefectures">
    <h3>{{ $t('message.prefectures_details') }}</h3>
    <table class="sheet">
      <tr>
        <th>{{ $t('noun.prefecture') }}</th>
        <th>{{ $t('noun.confirmed') }}</th>
        <th>{{ $t('noun.deceased') }}</th>
      </tr>
      <tr v-for="row in vision" :key="row.prefecture">
        <td>{{ row.prefecture }}</td>
        <td>{{ row.confirmed }}</td>
        <td>{{ row.deceased }}</td>
      </tr>
    </table>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Prefecture',
  computed: {
    ...mapState({
      vision: (state) => state.visions.prefectures || {},
    }),
  },
}
</script>

<style lang="less" scoped>
.prefectures {
  padding: 0 24px 48px;
  border-bottom: 1px solid #f9f9f9;
  h3 {
    color: #333;
    font-size: 24px;
    font-weight: bold;
    line-height: 1em;
    margin: 1.5em 0;
    padding: 0;
  }
  .sheet {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    border-radius: 4px;
    overflow: hidden;
    tr {
      line-height: 2em;
      background-color: #fff;
      border-bottom: 1px solid #eee;
      &:first-child {
        background-color: #eee;
      }
      th {
        text-transform: capitalize;
      }
      th, td {
        padding: 0.5em 1em;
        text-align: right;
        width: 4em;
        &:first-child {
          text-align: left;
          width: 12em;
        }
      }
    }
  }
}
</style>
